import * as React from 'react';

import { Location } from 'history';
import { Localized } from '@fluent/react';
import { NavLink } from 'react-router-dom';

import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';

import { RootState } from 'app/reducers';
import { UserActions, CommonActions } from 'app/actions';
import { UserProfile, SidebarType, RoleEnum } from 'app/models';

import ProfileWidget from 'app/components/ProfileWidget';
import { globalInitialState } from 'app/utils/initial-state';

const ICON_LOGOUT = require('../../../assets/icons/logout.svg');
const ICON_LOGO = require('../../../assets/icons/logo.svg');

const mapStateToProps = ({ common, user }: RootState) => ({
	openedSidebar: common.openedSidebar,
	profile: user.profile,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
	bindActionCreators(
		{
			toggleSidebar: CommonActions.toggleSidebar,
			logout: UserActions.logout,
		},
		dispatch,
	);

class SidebarMenu extends React.Component<SidebarMenu.Props, SidebarMenu.State> {
	public state: SidebarMenu.State = {};

	constructor(props: SidebarMenu.Props) {
		super(props);

		this.getList = this.getList.bind(this);
		this.getHeader = this.getHeader.bind(this);
	}

	private getHeader() {
		const { profile } = this.props;

		if (profile) {
			return <ProfileWidget profile={profile} />;
		} else {
			return null;
		}
	}

	private getList() {
		const { location, profile, toggleSidebar, openedSidebar } = this.props;

		const list = [
			{ text: 'menu-link-orders', page: '/panel/orders' },
			{ text: 'menu-link-profile', page: '/panel/profile' },
		];

		if (profile?.isDispatcher) {
			list.push({
				text: 'menu-link-admin',
				page: '/panel/admin',
			});
		}

		if (profile?.role === RoleEnum.Customer) {
			list.push({
				text: 'menu-link-transport',
				page: '/panel/transport/my',
			});
		}

		const closeSidebar = () => {
			if (toggleSidebar && openedSidebar) {
				toggleSidebar({ type: openedSidebar[0], value: false });
			}
		};

		return list.map(({ text, page }, index) => {
			if (page.indexOf('http') === 0) {
				return (
					<a key={page + index} className='item' href={page}>
						<Localized id={text} />
					</a>
				);
			}
			return (
				<NavLink
					activeClassName='active'
					onClick={closeSidebar}
					location={location}
					key={page + index}
					className='item'
					to={page}
				>
					<Localized id={text} />
				</NavLink>
			);
		});
	}

	public render() {
		const { logout } = this.props;

		return (
			<div className='navbar menu'>
				<div className='logo'>
					<img src={globalInitialState.logoUrl || ICON_LOGO} alt='' />
				</div>

				<div className='list'>{this.getList()}</div>

				<div className='fill' />

				{this.getHeader()}

				<div className='logout' onClick={logout}>
					<img src={ICON_LOGOUT} alt='' />
					<Localized id='menu-action-logout' />
				</div>
			</div>
		);
	}
}

export default connect<SidebarMenu.StateProps, SidebarMenu.DispatchProps, SidebarMenu.ExternalProps>(
	mapStateToProps,
	mapDispatchToProps,
)(SidebarMenu);

namespace SidebarMenu {
	export type Props = StateProps & DispatchProps & ExternalProps;

	// Props from redux mapState
	export interface StateProps {
		openedSidebar?: [SidebarType, boolean, any];
		profile?: UserProfile;
	}

	// Dispatch properties function from redux
	export interface DispatchProps {
		toggleSidebar?: (opt: CommonActions.Payload.ToggleSidebar) => void;
		logout?: () => void;
	}

	// Props from parent element e.g <Cmp custom={true} />
	export interface ExternalProps {
		location: Location;
	}

	// Main component state
	export interface State {}
}
